export type CommunityPlatform = 'whatsapp' | 'discord';

export interface AudienceCommunitySettings {
  platform: CommunityPlatform;
  whatsappLink: string;
  discordInviteUrl: string;
}

export interface CommunitySettings {
  aspirant: AudienceCommunitySettings;
  mentor: AudienceCommunitySettings;
  hackathon: AudienceCommunitySettings;
  discord: {
    jobWebhookUrl: string;
  };
}

const audienceDefaults: AudienceCommunitySettings = {
  platform: 'whatsapp',
  whatsappLink: '',
  discordInviteUrl: '',
};

export const DEFAULT_COMMUNITY_SETTINGS: CommunitySettings = {
  aspirant: { ...audienceDefaults },
  mentor: { ...audienceDefaults },
  hackathon: { ...audienceDefaults },
  discord: {
    jobWebhookUrl: '',
  },
};

export function mergeCommunitySettings(stored: Partial<CommunitySettings> | null | undefined): CommunitySettings {
  const base = stored && typeof stored === 'object' ? stored : {};
  const mergeAudience = (
    key: keyof Pick<CommunitySettings, 'aspirant' | 'mentor' | 'hackathon'>
  ): AudienceCommunitySettings => {
    const defaults = DEFAULT_COMMUNITY_SETTINGS[key];
    const aud = base[key];
    if (!aud || typeof aud !== 'object') return { ...defaults };
    return {
      platform: aud.platform === 'discord' ? 'discord' : 'whatsapp',
      whatsappLink: aud.whatsappLink ?? defaults.whatsappLink,
      discordInviteUrl: aud.discordInviteUrl ?? defaults.discordInviteUrl,
    };
  };

  return {
    aspirant: mergeAudience('aspirant'),
    mentor: mergeAudience('mentor'),
    hackathon: mergeAudience('hackathon'),
    discord: {
      jobWebhookUrl: base.discord?.jobWebhookUrl ?? DEFAULT_COMMUNITY_SETTINGS.discord.jobWebhookUrl,
    },
  };
}
